<template>
  <div class="qtype_wrapper">
    <b-form-group label="문제유형" v-if="has_qtype_open">
      <b-form-radio-group
        @change="chgQType"
        v-model="q_type"
        :options="q_type_options"
        name="radio-q-type"
      ></b-form-radio-group>
    </b-form-group>
    <div class="fixed_q_type" v-else>
      <div class="title">문제유형</div>
      <div class="bd">{{ q_type_text }}</div>
    </div>
  </div>
</template>

<script>
export default {
  watch: {
    q_type(to, from) {
      if (to == "5") {
        this.is_group = false;
        this.is_single = true;
        this.group_disabled = true;
      } else {
        this.is_group = false;
        this.is_single = true;
        this.group_disabled = false;
      }
    },
  },
  computed: {
    std_type() {
      return this.$store.state.questionmeta.std_type;
    },

    has_qtype_open() {
      return this.$store.state.questionform.id !== "" &&
        this.$store.state.questionform.id != null
        ? false
        : true;
      // return true;
      /* 
      if (this.grp_type == "1") {
        if (this.metaid != "") {
          return false;
        } else {
          return true;
        }
      } else {
        if (this.$store.state.qforms.length > 0) {
          return false;
        } else {
          return true;
        }
      }
      */
    },

    q_type: {
      get() {
        return this.$store.state.questionform.q_type;
      },
      set(val) {},
    },

    q_type_text() {
      let pos = parseInt(this.q_type);

      if (this.std_type === "2") {
        return this.$store.state.q_type_options[pos - 1].text;
      } else if (this.std_type === "3") {
        // return this.$store.state.q_type_reading_options[pos - 1].text;
        return "독해모의";
      } else {
        return [];
      }
    },
    q_type_options() {
      if (this.std_type === "2") {
        return this.$store.state.q_type_options;
      } else if (this.std_type === "3") {
        return this.$store.state.q_type_reading_options;
      } else {
        return [];
      }
    },
  },
  methods: {
    chgQType(val) {
      this.$store.commit("updateQType", val);
    },
  },
};
</script>


<style lang="scss" scoped>
.qtype_wrapper {
  background-color: lightgray;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 10px;
}
</style>